//Login
export const REQUEST_OTP = "REQUEST_OTP";
export const VALIDATE_OTP = "VALIDATE_OTP";
export const VERIFY_PHONE_NUMBER = "VERIFY_PHONE_NUMBER";

// ORGANIZATION
export const GET_USER_DETAILS = "GET_USER_DETAILS";
export const REQUEST_ORGANIZATIONS = "REQUEST_ORGANIZATIONS";
export const SAVE_ORGANIZATIONS_LIST = "SAVE_ORGANIZATIONS_LIST";
export const CREATE_ORGANIZATION = "CREATE_ORGANIZATION";
export const SYNC_TEMPLATES = "SYNC_TEMPLATES";
export const REQUEST_ORGANIZATION = "REQUEST_ORGANIZATION";
export const STORE_ORGANIZATION = "STORE_ORGANIZATION";
export const REQUEST_ORGANIZATIONS_APPS = "REQUEST_ORGANIZATIONS_APPS";
export const STORE_ORGANIZATIONS_APPS = "STORE_ORGANIZATIONS_APPS";

//SIMS
export const CREATE_SIM = "CREATE_SIM";
export const REQUEST_SIMS = "REQUEST_SIMS";
export const SAVE_SIMS_LIST = "SAVE_SIMS_LIST";
export const SAVE_ADD_SIM_MODAL_STATUS = "SAVE_ADD_SIM_MODAL_STATUS";
export const SAVE_ADD_SIM_MODAL_DATA = "SAVE_ADD_SIM_MODAL_DATA";
export const REQUEST_DELETE_SIM_SAGA = "REQUEST_DELETE_SIM_SAGA";
export const REQUEST_SUSPEND_SIM_SAGA = "REQUEST_SUSPEND_SIM_SAGA";
export const REQUEST_ACTIVATE_SIM_SAGA = "REQUEST_ACTIVATE_SIM_SAGA";
export const REQUEST_DEACTIVATE_SIM_SAGA = "REQUEST_DEACTIVATE_SIM_SAGA";
export const REQUEST_SEND_EDIT_SIM_DATA_SAGA = "REQUEST_SEND_EDIT_SIM_DATA_SAGA";
export const REQUEST_SEND_ADD_SIM_DATA_SAGA = "REQUEST_SEND_ADD_SIM_DATA_SAGA";
export const REQUEST_SIM_USAGE_DETAILS_SAGA = "REQUEST_SIM_USAGE_DETAILS_SAGA";
export const SAVE_SIM_USAGE_DETAILS = "SAVE_SIM_USAGE_DETAILS";

// INVENTORY
export const REQUEST_INVENTORY_LIST_SAGA = "REQUEST_INVENTORY_LIST_SAGA";
export const REQUEST_ADD_INVENTORY_SAGA = "REQUEST_ADD_INVENTORY_SAGA";
export const REQUEST_SYSTEM_PROFILE_DATA = "REQUEST_SYSTEM_PROFILE_DATA";
export const REQUEST_DELETE_INVENTORY_SAGA = "REQUEST_DELETE_INVENTORY_SAGA";
export const REQUEST_SUSPEND_INVENTORY_SIM_SAGA = "REQUEST_SUSPEND_INVENTORY_SIM_SAGA";
export const REQUEST_TOGGLE_INVENTORY_COMMISSION_SAGA =
  "REQUEST_TOGGLE_INVENTORY_COMMISSION_SAGA";

export const SAVE_SYSTEM_PROFILE_DATA = "SAVE_SYSTEM_PROFILE_DATA";
export const REQUEST_SIM_DROPDOWN_DATA = "REQUEST_SIM_DROPDOWN_DATA";
export const SAVE_SIM_DROPDOWN_DATA = "SAVE_SIM_DROPDOWN_DATA";

export const SAVE_INVENTORY_LIST = "SAVE_INVENTORY_LIST";

export const STORE_EDIT_INVENTORY_DATA = "STORE_EDIT_INVENTORY_DATA";

// DASHBOARD
export const REQUEST_CARD_DATA = "REQUEST_CARD_DATA";
export const SAVE_CARD_DATA = "SAVE_CARD_DATA";

//USERS
export const SAVE_ADD_USER_MODAL_STATUS = "SAVE_ADD_USER_MODAL_STATUS";
export const SAVE_ADD_USER_MODAL_DATA = "SAVE_ADD_USER_MODAL_DATA";
export const REQUEST_SEND_ADD_USER_DATA_SAGA = "REQUEST_SEND_ADD_USER_DATA_SAGA";
export const REQUEST_GET_USERS_LIST_SAGA = "REQUEST_GET_USERS_LIST_SAGA";
export const SAVE_GET_USERS_LIST = "SAVE_GET_USERS_LIST";
export const REQUEST_SEND_EDIT_USER_DATA_SAGA = "REQUEST_SEND_EDIT_USER_DATA_SAGA";
export const REQUEST_DELETE_USER_SAGA = "REQUEST_DELETE_USER_SAGA";
export const GET_USER_PROFILE = "GET_USER_PROFILE";
export const STORE_USER_PROFILE = "STORE_USER_PROFILE";

//GROUP
export const REQUEST_GROUP_LIST_SAGA = "REQUEST_GROUP_LIST_SAGA";
export const REQUEST_ADD_GROUP_SAGA = "REQUEST_ADD_GROUP_SAGA";
export const SAVE_GROUP_LIST = "SAVE_GROUP_LIST";
export const REQUEST_PERMISSION_LIST = "REQUEST_PERMISSION_LIST";
export const SAVE_PERMISSION_LIST = "SAVE_PERMISSION_LIST";
export const REQUEST_USER_LIST = "REQUEST_USER_LIST";
export const SAVE_USER_LIST = "SAVE_USER_LIST";

export const SAVE_ADD_GROUP_MODAL_STATUS = "SAVE_ADD_GROUP_MODAL_STATUS";
export const SAVE_ADD_GROUP_MODAL_DATA = "SAVE_ADD_GROUP_MODAL_DATA";
export const REQUEST_SEND_ADD_GROUP_DATA_SAGA = "REQUEST_SEND_ADD_GROUP_DATA_SAGA";
export const REQUEST_SEND_EDIT_GROUP_DATA_SAGA = "REQUEST_SEND_EDIT_GROUP_DATA_SAGA";
export const REQUEST_DELETE_GROUP_SAGA = "REQUEST_DELETE_GROUP_SAGA";

// Inventory Reports
export const REQUEST_INVENTORY_REPORTS = "REQUEST_INVENTORY_REPORTS";
export const STORE_INVENTORY_REPORTS = "STORE_INVENTORY_REPORTS";

// Jobs
export const REQUEST_JOBS = "REQUEST_JOBS";
export const STORE_JOBS = "STORE_JOBS";
export const REQUEST_JOB = "REQUEST_JOB";
export const STORE_JOB = "STORE_JOB";

// NotificationMenu
export const REQUEST_NOTIFICATIONS = "REQUEST_NOTIFICATIONS";
export const STORE_NOTIFICATIONS = "STORE_NOTIFICATIONS";
export const MARK_NOTIFICATION_READ = "MARK_NOTIFICATION_READ";
export const MARK_ALL_NOTIFICATION_READ = "MARK_ALL_NOTIFICATION_READ";
export const DELETE_NOTIFICATIONS = "DELETE_NOTIFICATIONS";

//Login
export const VERIFY_EMAIL = "VERIFY_EMAIL";
export const VERIFY_TOKEN = "VERIFY_TOKEN";
export const RESET_PASSWORD = "RESET_PASSWORD";

// User settings
export const SAVE_USER_SETTINGS = "SAVE_USER_SETTINGS";

//Theme
export const STORE_THEME = "STORE_THEME";
